<!--
  Sivutason toimintonapit yhdestä listasta.

  Käyttö yläpalkissa (hb-basic-page, slot app-bar-extension):
    <hb-page-actions :actions="pageActions" />
  Käyttö mobiilissa sivun sisällössä (speed dial oikeassa alakulmassa):
    <hb-page-actions :actions="pageActions" speed-dial />
  Valikkonapin teksti ja kuvake: menu-label (oletus "Uusi") ja menu-icon (oletus mdi-plus).

  actions: [{ text, icon, handler, primary?, show?, disabled?, loading? }]
  - primary: true  -> oma nappi yläpalkissa
  - muut            -> yhteen pudotusvalikkoon, joka näytetään ensimmäisen valikkotoiminnon kohdalla
  - show: false     -> toiminto piilotetaan kokonaan
  Speed dial näyttää kaikki näkyvät toiminnot listan järjestyksessä, ensimmäinen lähimpänä nappia.
-->
<template>
  <v-speed-dial
    v-if="speedDial"
    v-model="open"
    class="page-actions-speed-dial"
    direction="top"
    transition="slide-y-reverse-transition"
    bottom
    fixed
    right
  >
    <template v-slot:activator>
      <v-btn v-model="open" color="primary" dark fab>
        <v-icon class="no-gradient">{{ open ? 'mdi mdi-close' : 'mdi mdi-plus' }}</v-icon>
      </v-btn>
    </template>
    <v-btn
      v-for="(action, i) in visibleActions"
      :key="i"
      :dark="!(disabled || action.disabled)"
      :disabled="disabled || action.disabled"
      :loading="action.loading"
      color="primary darken-1"
      rounded
      @click="action.handler()"
    >
      <v-icon class="no-gradient" left>{{ action.icon }}</v-icon>
      {{ action.text }}
    </v-btn>
  </v-speed-dial>

  <div v-else class="d-flex align-center ml-n1">
    <template v-for="(action, i) in visibleActions">
      <v-btn
        v-if="action.primary"
        :key="i"
        :disabled="disabled || action.disabled"
        :loading="action.loading"
        class="mb-3 mr-3"
        color="primary"
        dark
        @click="action.handler()"
      >
        <v-icon class="no-gradient" left>{{ action.icon }}</v-icon>
        <span>{{ action.text }}</span>
      </v-btn>
      <v-menu v-else-if="action === menuActions[0]" :key="i" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" :disabled="disabled" class="mb-3 mr-3" color="primary" dark>
            <v-icon class="no-gradient" left>{{ menuIcon }}</v-icon>
            <span>{{ menuLabel }}</span>
            <v-icon class="no-gradient" right>mdi mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list dense>
          <v-list-item v-for="(menuAction, j) in menuActions" :key="j" :disabled="menuAction.disabled" @click="menuAction.handler()">
            <v-list-item-icon>
              <v-icon>{{ menuAction.icon }}</v-icon>
            </v-list-item-icon>
            <v-list-item-title>{{ menuAction.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </template>
  </div>
</template>

<script>
export default {
  name: 'PageActions',
  props: {
    actions: {
      type: Array,
      required: true,
    },
    speedDial: {
      type: Boolean,
      default: false,
    },
    menuLabel: {
      type: String,
      default() {
        return this.$t('new');
      },
    },
    menuIcon: {
      type: String,
      default: 'mdi mdi-plus',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      open: false,
    };
  },
  computed: {
    visibleActions() {
      return this.actions.filter(action => action.show !== false);
    },
    menuActions() {
      return this.visibleActions.filter(action => !action.primary);
    },
  },
};
</script>

<style lang="scss">
// Vuetify keskittää listan aktivointinapin päälle; tasataan oikeaan reunaan, jotta pitkät tekstit avautuvat vasemmalle.
.page-actions-speed-dial .v-speed-dial__list {
  left: auto;
  right: 0;
  width: auto;
  align-items: flex-end;
}
</style>
